import { gsap, ScrollTrigger, SplitText } from 'gsap/all'
gsap.registerPlugin(SplitText, ScrollTrigger)

export function splitTitle(
  title: HTMLElement,
  scrolltriggerAttributes?: {
    trigger?: HTMLElement
    start?: string
    end?: string
    markers?: boolean
    duration?: number
  }
) {
  const { trigger, start, end, markers, playImmediately } = scrolltriggerAttributes || {}
  const innerChars = new SplitText(title, {
    type: 'chars, words',
    linesClass: 'lineChild'
  })

  const outerTitle = new SplitText(title, {
    type: 'lines',
    linesClass: 'lineParent'
  })

  gsap.set(innerChars.chars, {
    'will-change': 'opacity, transform',
    'opacity': 0,
    'yPercent': 120,
    'scaleY': 2.3,
    'scaleX': 0.7,
    'transformOrigin': '50% 0%'
  })

  runTitleAnim()

  setTimeout(() => {
    // refresh scrolltrighger
    ScrollTrigger.refresh()
  }, 1000)

function myCustomFunction() {
  console.log("Custom function is running!");
  // Add your logic here
}
  function runTitleAnim() {
    // get parent section
    const parentSection = title.closest('section')
    let allow = scrolltriggerAttributes?.allow
    let duration = scrolltriggerAttributes?.duration
    let stagger = scrolltriggerAttributes?.stagger
    let ease = scrolltriggerAttributes?.ease

    if (playImmediately === true) {
      gsap.to(innerChars.chars, {
        duration: duration || 1.15,
        ease: ease || 'back.inOut(1.6)',
        opacity: 1,
        yPercent: 0,
        scaleY: 1,
        scaleX: 1,
        stagger: stagger || 0.02
      })
    } else {
      const titleAnim = gsap.timeline({
        scrollTrigger: {
          trigger: trigger || parentSection,
          // trigger: trigger ? trigger : title,
          start: start || 'top-=25% bottom',
          end: end || 'center bottom',
          // scrub: true,
          once: true,
          invalidateOnRefresh: true,
          markers: markers || false,
          toggleActions: 'play none none reverse',
onEnter: () => {
          console.log("Section is now visible in the viewport!");
          myCustomFunction(); // Call your separate function here
        },
        onLeave: () => {
          console.log("Section has left the viewport!");
        },
        onEnterBack: () => {
          console.log("Section is back in the viewport!");
        },
        onLeaveBack: () => {
          console.log("Section is leaving again!");
        }
        }
      })

      titleAnim.to(innerChars.chars, {
        duration: duration || 1.15,
        ease: ease || 'back.inOut(1.6)',
        opacity: 1,
        yPercent: 0,
        scaleY: 1,
        scaleX: 1,
        stagger: stagger || 0.02
      })
    }
  }
}
